export class ListStatusCount {
    TotalPending: number;
    TotalExpiring: number;
    TotalExpired: number;

    constructor(){}
}